(function () {
  function toPositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function updateSection(section, visibleCount) {
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-events-category-card]"));
    var button = section.querySelector("[data-events-category-load-more]");
    var actions = button ? button.closest(".events-by-category__actions") : null;

    cards.forEach(function (card, index) {
      card.hidden = index >= visibleCount;
    });

    if (actions) {
      actions.hidden = visibleCount >= cards.length;
    }
  }

  function initEventsByCategory(root) {
    if (!root || root.dataset.eventsByCategoryInitialized === "true") return;

    var initialCount = toPositiveInteger(root.dataset.initialCount, 6);
    var loadCount = toPositiveInteger(root.dataset.loadCount, 3);
    var sections = root.querySelectorAll("[data-events-category-section]");
    var navLinks = Array.prototype.slice.call(root.querySelectorAll("[data-events-category-nav-link]"));
    var select = root.querySelector("[data-events-category-select]");

    root.dataset.eventsByCategoryInitialized = "true";
    root.classList.add("is-enhanced");
    revealSection(root);

    sections.forEach(function (section) {
      var cards = section.querySelectorAll("[data-events-category-card]");
      var button = section.querySelector("[data-events-category-load-more]");
      var visibleCount = initialCount;

      if (!cards.length) return;

      updateSection(section, visibleCount);

      if (button) {
        button.addEventListener("click", function () {
          visibleCount = Math.min(visibleCount + loadCount, cards.length);
          updateSection(section, visibleCount);
        });
      }
    });

    initActiveNav(root, sections, navLinks, select);
  }

  function setActiveNav(navLinks, select, id) {
    var value = "#" + id;

    navLinks.forEach(function (link) {
      link.classList.toggle("is-active", link.getAttribute("href") === value);
    });

    if (select && select.value !== value) {
      select.value = value;
    }
  }

  function initActiveNav(root, sections, navLinks, select) {
    if (!sections.length || (!navLinks.length && !select)) return;

    var firstSection = sections[0];

    navLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        var id = (link.getAttribute("href") || "").replace("#", "");
        if (id) setActiveNav(navLinks, select, id);
      });
    });

    if (select) {
      select.addEventListener("change", function () {
        var hash = select.value || "";
        var target = hash ? document.getElementById(hash.replace("#", "")) : null;

        if (!target) return;

        setActiveNav(navLinks, select, target.id);
        history.replaceState(null, "", hash);
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }

    if (window.location.hash) {
      setActiveNav(navLinks, select, window.location.hash.replace("#", ""));
    } else if (firstSection && firstSection.id) {
      setActiveNav(navLinks, select, firstSection.id);
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target.id) {
            setActiveNav(navLinks, select, entry.target.id);
          }
        });
      },
      {
        rootMargin: "-35% 0px -55% 0px",
        threshold: 0
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function revealSection(root) {
    if (!document.documentElement.classList.contains("do-anim")) {
      root.classList.add("is-visible");
      return;
    }

    if (!("IntersectionObserver" in window)) {
      root.classList.add("is-visible");
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add("is-visible");
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="events-by-category"]').forEach(initEventsByCategory);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
